import { Box, Typography } from '@mui/material';
import parse from 'html-react-parser';

import MessageDate from '../MessageDate';
import UnreadNotification from '../UnreadNotification';
import { MessageItemSectionProps } from '../../MessageList.interface';
import showUnreadNotification from '../UnreadNotification/utils';

import useZDUser from 'services/help-center/queries/useZDUser';
import sanitizeHtml from 'modules/common/utils/sanitizeHtml';

export default function TitleSection({ ticket }: MessageItemSectionProps) {
    const { data: zdUser } = useZDUser();
    const showNotification = showUnreadNotification(ticket, zdUser);
    const lastComment = ticket.last_comment?.public ? ticket.last_comment : undefined;

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography
                component="span"
                color="primary.main"
                fontSize="0.875rem"
                fontWeight={400}
                sx={{ position: 'relative' }}>
                <UnreadNotification show={showNotification} />
                {parse(sanitizeHtml(ticket?.subject ?? ''))}
            </Typography>
            <Typography component="span" color="cement.500" fontSize="0.875rem">
                <MessageDate
                    createdDate={
                        (lastComment?.created_at || ticket.last_comment?.created_at || ticket.created_at) ?? ''
                    }
                />
            </Typography>
        </Box>
    );
}
